import { Errors } from './Errors'
import { Validator } from './Validator'

import { isEmpty } from '../helpers/objects'

export class Form {

    /**
     * Create a new Form instance.
     *
     * @param {object} data
     */
    constructor(data, multipart) {
        this.original_data = data

        for (let field in data) {
            this[field] = data[field]
        }

        this.errors = new Errors()
        this.validator = new Validator()

        if(multipart) {
            this.setHeaders('multipart')
        }
    }


    /**
     * Fetch all relevant data for the form.
     */
    data() {
        let data = {};

        for (let property in this.original_data) {
            data[property] = this[property]
        }

        return data
    }


    /**
     * Reset the form fields.
     */
    reset() {
        for (let field in this.original_data) {
            this[field] = ''
        }

        this.errors.clear()
    }


    setHeaders(multipart) {
        if(multipart) {
            return {
                'Content-Type': 'multipart/form-data'
            }
        }

        return {}
    }

    /**
     * Send a POST request to the given URL.
     * .
     * @param {string} url
     */
    post(url, options) {
        return this.submit('post', url, options)
    }


    /**
     * Send a PUT request to the given URL.
     * .
     * @param {string} url
     */
    put(url) {
        return this.submit('put', url)
    }


    /**
     * Send a PATCH request to the given URL.
     * .
     * @param {string} url
     */
    patch(url) {
        return this.submit('patch', url)
    }


    /**
     * Send a DELETE request to the given URL.
     * .
     * @param {string} url
     */
    delete(url) {
        return this.submit('delete', url)
    }


    /**
     * Submit the form.
     *
     * @param {string} method
     * @param {string} url
     */
    submit(method, url, options) {
        isLoading()

        return new Promise((resolve, reject) => {
            axios[method](url, this.data(), this.setHeaders())
                .then(response => {
                    stopLoading()

                    this.onSuccess(response.data, options)

                    resolve(response.data)
                })
                .catch(response => {
                    stopLoading()

                    reject(response)

                    this.onFail(response.data.errors)
                })
        })
    }


    /**
     * Handle a successful form submission.
     *
     * @param {object} data
     */
    onSuccess(data, options = {}) {
        if (!('reset' in options) || (options.reset != false)) {
            this.reset()
        }
    }


    /**
     * Handle a failed form submission.
     *
     * @param {object} errors
     */
    onFail(errors) {
        if(errors) {
            this.errors.record(errors)
        }
    }

    validate(rules) {
        let errors = this.validator.validate(rules, this.data())

        if(! isEmpty(errors)) {
            this.errors.record(errors)

            return false
        }

        return true
    }
}